import React from "react"
import styled from "styled-components"
// import {Jua} from "@import url('https://fonts.googleapis.com/css2?family=Jua&display=swap');"
const Styled = {
    Wrap:styled.div`
        width:100%;
        height:50px;
        display:flex;
        justify-content: center;
        align-items: center;
        background-color: beige;
    `,
    Font:styled.p`
        font-size:30px;
        color:#000;
        font-weight: 700;
        font-family:"Jua", sans-serif;
    `,
}
const Header =()=>{
    return(
        <Styled.Wrap>
            <Styled.Font>신혼부부 청약점수 구하기!</Styled.Font>
        </Styled.Wrap>
    )
}
export default Header